var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"n-icon",class:{ 'n-icon-center': _vm.center },style:(_vm.auto + _vm.xs + _vm.small + _vm.medium + _vm.large + _vm.xl + _vm.xxl + _vm.xxxl + _vm.white + _vm.black),attrs:{"src":_vm.icon,"alt":"Icon"}})}
var staticRenderFns = []

export { render, staticRenderFns }